import {Link} from "react-router-dom";
import MobileSidebar from "./mobile-sidebar";
import React, {useState} from "react";

const MobileMenu = ({
                      secondLogo,
                      lienLogo,
                      lienPage,
                      altLogo,
                      showMenu,
                      page
}) => {

  const [showSidebar, setShowSidebar] = useState(false);

  const handleToggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  return (
      <header className="main-header main-header-mobile">
            <div className="auto-container">
              {/* <!-- Main box --> */}
              <div className="inner-box">
                <div className="nav-outer">
                  <div className="logo-box">
                    <div className="logo">
                      <Link to={lienPage || "/boursorama"}>
                        <img
                            src="/images/webinaires-TH-1.png"
                            alt="Logo webinaires Talents Handicap"
                        />
                      </Link>
                      {secondLogo && (
                          <Link to={lienPage || "/boursorama"}>
                            <img
                                width={150}
                                src={lienLogo || "/images/bourso.png"}
                                alt={altLogo || "Logo Webinaires Talents Handicap"}
                            />
                          </Link>
                      )}
                    </div>
                  </div>
                  {/* End .logo-box */}

                  <MobileSidebar
                      show={showSidebar}
                      onClose={handleToggleSidebar}
                      lien={lienPage || "/boursorama"}
                      logo={lienLogo || "/images/bourso.png"}
                      page={page}
                  />
                  {/* <!-- Main Menu End--> */}
                </div>
                {/* End .nav-outer */}

                <div className="outer-box">
                  {showMenu && (
                    <button
                        className="mobile-nav-toggler"
                        onClick={handleToggleSidebar}
                    >
                      <img
                          width={25}
                          src="/images/icons/icon-menu.png"
                          alt='ico menu'
                      />
                      {/*<span className="flaticon-menu-1"></span>*/}
                    </button>
                  )}
                  {/* right hamburger menu */}
                </div>
              </div>
            </div>
          </header>
  );
};

export default MobileMenu;
